import React from 'react';
import classNames  from 'classnames';

export default (props) => (
  <div className={classNames('question-accordion-head', {
    'completed': props.questionType === 'completed',
    'wait': props.questionType === 'waite',
    'wrong': props.questionType === 'wrong'
  })
  }>
    <div className="question-accordion-head-inner">
      <span className={classNames('question-accordion-head-icon', {
        'ic-comleted-answer-ico': props.questionType === 'completed',
        'ic-wait-answer-ico': props.questionType === 'waite',
        'ic-wrong-answer-ico': props.questionType === 'wrong'
      })}/>
      <div className="question-accordion-caption">
        <p className="question-accordion-label">{props.label}</p>
        <p className="question-accordion-title">{props.caption}</p>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/questions/QuestionHead.jsx